import { Loader, Overlay } from '@mantine/core';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Show } from '../../../../../../react-commons/components/control-flow/Show';
import { isBackgroundProcessInProgress } from '../../../util/useSelectorFunctions';
import './StatusComponent.scss';

export const StatusComponent = () => {
    const showProgressSpinner = useSelector(isBackgroundProcessInProgress);

    return (
        <Show when={showProgressSpinner}>
            <Overlay
                style={{
                    zIndex: 9999,
                    color: '#fff',
                }}
                backgroundOpacity={0.6}
            >
                <Loader size={50} pos={'absolute'} top={'50%'} left={'50%'} color={'primaryTeal.6'} />
            </Overlay>
        </Show>
    );
};
